<template>
  <BaseAction>
    <div class="d-flex justify-center request-references">
      <SecondaryButton @click.native="openDialog" textColor="#0965dc">
        <v-img
          src="@/assets/svg/request_references.svg"
          class="offer-action-icon"
          size="50"
        />
        <span :class="{ 'ml-1': isMobile }"> Request References </span>
      </SecondaryButton>
      <RequestReferencesDialog v-if="isOpen" @close="closeDialog" />
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import RequestReferencesDialog from "@/views/offers/dialogs/RequestReferencesDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "RequestReferencesAction.vue",
  components: {
    SecondaryButton,
    RequestReferencesDialog,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss">
.request-references {
  .offer-action-icon {
    width: auto !important;
    height: auto !important;
  }
}
</style>
